/**
 * Row actions: more-options IconButton with context menu.
 */
import React from "react";
import { IconButton } from "@fluentui/react/lib/Button";

/**
 * @param {{ item: object, menuProps: object, theme: object }} props
 */
export function CheckInNewRowActions({ item, menuProps, theme }) {
  return (
    <IconButton
      menuProps={typeof menuProps === "function" ? menuProps(item) : menuProps}
      menuIconProps={{ iconName: "More" }}
      styles={{
        root: {
          color: theme.colors.themeDarkColor,
          fontFamily: theme.fonts.regular,
          fontSize: theme.fontSizes.medium,
          minHeight: 0,
          height: "100%",
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          selectors: {
            ".ms-ContextualMenu-itemText": {
              fontFamily: theme.contextMenu?.fontFamily ?? theme.fonts.regular,
              fontSize: theme.contextMenu?.fontSize ?? theme.fontSizes?.menusize ?? 12,
              backgroundColor: theme.colors.msTeamsFilesHover,
            },
            ".ms-ContextualMenu-linkContent": {
              fontFamily: theme.contextMenu?.fontFamily ?? theme.fonts.regular,
              fontSize: theme.contextMenu?.fontSize ?? theme.fontSizes?.menusize ?? 12,
              backgroundColor: theme.colors.msTeamsFilesHover,
            },
          },
        },
      }}
    />
  );
}
